import React from 'react'

export default function Sidebar() {
    return (
        <div className="Sidebar border-l h-screen">
            <p>coming soon .....</p>
        </div>
    )
}
